/**
 * All the flags Identity subscribes to from Launch Darkly.
 *
 * Flags could be created in Launch Darkly as camelCase or kebab-case. Identity
 * is only supporting camelCase so make sure flags are using that convention
 * when created in Launch Darkly.
 */
export const subscribedFlags = {
  accountNavMakeover: false,
  identityPoloMemberAccess: false,
  txmSideNavigation: false,
  txmSideNavigationToggle: false,
  paymentExternalBankAccount: false,
  accountProfileMakeover: false,
  aiChat: false,
};

export type SubscribedFlags = typeof subscribedFlags;
export type SubscribedFlag = keyof SubscribedFlags;
